export default {
  title: 'Prisdetaljer',
  subtotal: 'Subtotal',
  method_fee: 'Leveringsgebyr',
  tip: 'Drikkepenge',
  service_fee: 'Onlinebehandling',
  payment_method_upcharge_fee: 'PayPal-gebyr',
  discount: 'Rabat',
  taxes: 'Skatter',
  total: 'I alt',
};
